'use strict';

import {addExportBtns} from "../../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../../functions";

export var fnEmployeesOptionalsTable = function () {

    var tableName = '#datatable-employees-optionals';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    var columns = [
        {data: 'id'},
        {data: 'name'},
        {data: 'flex_savings'},
        {data: 'days_vacation'},
        {data: 'production_unit'},
        {data: 'danmarks_statistik'},
        {data: 'health_insurance'},
        {data: 'has_free_car'},
        {data: 'kilometer'},
        {data: 'has_free_phone'},
        {data: 'has_lunch_arrangement'},
        {data: 'has_pension'},        
        {data: 'diaeter'},
        {data: 'has_fixed_add_ons'},
        {data: 'action'}
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {visible: false, targets: 0},
    ];


    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');

    var table = $(tableName).DataTable({

        language: allLangFiles.datatables,
        rowId: 'id',
        ajax: {
            url: '/company/employees-optionals/table',
            dataSrc: function (json) {

                return json.data;
            },
        },
        columns: columns,
        columnDefs: columnDefs,
        scrollX: true,
        lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
    });
    //addSearchColumn(tableName, table);
    addExportBtns($(tableName));
    redesignDataTablesHeader(tableName, false, null, false);
};
